import React from "react";
import { Popconfirm } from "antd";

import {
  PrimaryButton,
  PendingButton,
  ApprovedButton,
  RejectedButton,
} from "../button";

import images from "../../assets";

export default function UserProfileGalleryBox({
  galleryData,
  image,
  imageoriginal,
  status,
  updateProfile,
  ...props
}) {
  const handleDelete = () => {
    console.log("delete image", imageoriginal);
    const updatedGalleryData = galleryData?.filter(
      (img) => img.originalUrl !== imageoriginal
    );
    updateProfile(updatedGalleryData);
  };
  return (
    <div
      {...props}
      className="w-[270px] bg-white rounded-lg shadow border border-primary50 p-4 justify-between gap-4 flex-col flex"
    >
      <img
        className="aspect-square w-full min-w-[150px] rounded-xl object-cover"
        src={image}
        alt="img"
      />
      <div className="w-full justify-between flex">
        <div className="w-full justify-start items-center gap-2 flex">
          <p>Status:</p>
          {status === "active" || status === "approved" ? (
            <ApprovedButton />
          ) : status === "pending" ? (
            <PendingButton />
          ) : (
            <RejectedButton />
          )}
        </div>
        <Popconfirm
          title="Delete photo?"
          description="Are you sure to delete this photo?"
          onConfirm={handleDelete}
          okText="Yes"
          cancelText="No"
        >
          <img
            src={images.deleteIcon}
            alt="delete"
            className="cursor-pointer"
          />
        </Popconfirm>
      </div>
    </div>
  );
}
